/* Component Dependencies */
var parkingInfoTemplate = require('templates/hotelParkingInformation.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'hotelParkingInformation',
  template: {
    'hotelParkingInformation': parkingInfoTemplate
  }
});
